import { cn } from '@repo/ui/utils'
import { ReactNode } from 'react'

type ViewProps = {
  children?: ReactNode
  className?: string
}

export function View({ children, className }: ViewProps) {
  return (
    <div className={cn('relative flex h-screen', className)}>{children}</div>
  )
}
